import { Spinner } from "./Spinner";
import { cn } from "@/lib/utils";

export interface LoadingStateProps {
  loadingLabel: string;
  message?: string;
  className?: string;
}

export function LoadingState({
  loadingLabel,
  message,
  className,
}: LoadingStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4 py-16",
        className,
      )}
    >
      <Spinner size="lg" loadingLabel={loadingLabel} />
      {message ? (
        <p className="animate-pulse text-sm text-surface-500">{message}</p>
      ) : null}
    </div>
  );
}
